import React from "react";

export default function Productionrepair() {
  return (
    <div>
      <div class="flex flex-wrap justify-center">
        <div class="w-full md:overflow-x-auto sm:overflow-x-auto mt-8 bg-white  mb-4  shadow-md shadow-slate-400 rounded-2xl">
          <div className="flex flex-wrap mt-1 pt-2">
            <h3 className="text-lg font-bold mx-3"> Amount of Repairs</h3>
            <div className="float-right ml-auto mr-4 mt-1">
              <div className="float-right">
                <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                  {" "}
                  M
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                  {" "}
                  Y
                </button>
              </div>
              <div className="relative text-gray-600 mr-3  border-1 rounded-3xl float-right focus-within:text-gray-400">
                <span className="absolute text-slate-400 inset-y-0 left-0 flex items-center pl-2">
                  <button
                    type="submit"
                    className="p-1 focus:outline-none focus:shadow-outline"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4 6h16M4 12h8m-8 6h16"
                      />
                    </svg>
                  </button>
                </span>
                <input
                  type="search"
                  className="py-2 text-sm outline-slate-100 outline focus:outline-slate-200 rounded-full pl-10 focus:outline-1 focus:bg-white focus:text-gray-900"
                  placeholder="Filter"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <div
            className="tabelcontainer overflow-auto"
            // "w-[calc(100vw_-_12rem)]"
          >
            <table className="w-full md:overflow-x-auto mt-9 overflow-x-auto sm:overflow-x-auto text-sm text-left text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase  ">
                <tr className=" border-white ">
                  <th scope="col" className="px-6 py-3"></th>
                  <th scope="col" className="px-6 py-3"></th>
                  <th scope="col" className="px-6 py-3"></th>
                  <th scope="col" className="px-6 py-3"></th>
                  <th scope="col" className="px-6 py-3"></th>
                </tr>
              </thead>
              <tbody>
                <tr className=" border-white  hover:bg-orange-200 hover:cursor-pointer">
                  <th
                    scope="row"
                    className="px-6 py-4 font-bold text-gray-900 "
                  >
                    20/Nov/2021
                  </th>
                  <td className="px-6 text-gray-900 py-4 font-medium">
                    Lorem ipsum{" "}
                  </td>
                  <td className="px-6 text-red-400 py-4 font-medium">
                    On Going
                  </td>
                  <td className="px-6 text-gray-900 py-4 font-medium text-center">
                    2999 USD
                  </td>
                </tr>
                <tr className=" border-white hover:bg-orange-200 hover:cursor-pointer">
                  <th
                    scope="row"
                    className="px-6 py-4 font-bold text-gray-900 "
                  >
                    20/Nov/2021
                  </th>
                  <td className="px-6 py-4 text-gray-900 font-medium ">
                    Lorem ipsum{" "}
                  </td>
                  <td className="px-6 py-4  font-medium text-red-400 ">
                    On Going
                  </td>
                  <td className="px-6 py-4 text-gray-900 font-medium text-center">
                    $1999 USD
                  </td>
                </tr>
                <tr className=" border-white  hover:bg-orange-200 hover:cursor-pointer ">
                  <th
                    scope="row"
                    className="px-6 py-4 font-bold text-gray-900 "
                  >
                    20/Nov/2021
                  </th>
                  <td className="px-6 py-4 text-gray-900 font-medium">
                    Lorem ipsum{" "}
                  </td>
                  <td className="px-6 py-4 text-red-400 font-medium">Solved</td>
                  <td className="px-6 py-4 text-gray-900 font-medium text-center">
                    990 USD
                  </td>
                </tr>
                <tr className="  border-white  hover:bg-orange-200 hover:cursor-pointer ">
                  <th
                    scope="row"
                    className="px-6 py-4 font-bold text-gray-900 "
                  >
                    20/Nov/2021
                  </th>
                  <td className="px-6 py-4 text-gray-900 font-medium">
                    Lorem ipsum{" "}
                  </td>
                  <td className="px-6 py-4 text-red-400 font-medium">
                    On Going
                  </td>
                  <td className="px-6 py-4 text-gray-900 font-medium text-center">
                    99 USD
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
